module.exports = "<div class=\"ssf-spinner__fadeout\" *ngIf=\"show\">\n    <em class=\"ssf-spinner ssf-spinner_large\" aria-live=\"polite\" aria-busy=\"true\" title=\"{{ i18n + 'LOADING' | translate }}\"><i></i><i></i><i></i><i></i><i></i></em>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/spinner/spinner.component.html
// module id = 658
// module chunks = 3